module.exports = __webpack_public_path__ + "img/6-diamond.361574a5.png";